module.exports = __webpack_public_path__ + "linea-arrows-10.5873a30e6baace5f9246.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/linea/fonts/linea-arrows-10.svg
// module id = ../../../../../src/assets/linea/fonts/linea-arrows-10.svg
// module chunks = styles